import { render, staticRenderFns } from "./EventsFiltersSummary.vue?vue&type=template&id=716dc675"
import script from "./EventsFiltersSummary.vue?vue&type=script&lang=js"
export * from "./EventsFiltersSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports